import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import { aboutService, siteContentService } from '../services/api';

function EditorialBoard() {
  const [editorialBoardDesc, setEditorialBoardDesc] = useState('');
  const [boardMembers, setBoardMembers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const aboutResponse = await aboutService.get();
        if (aboutResponse.data) {
          setEditorialBoardDesc(aboutResponse.data.editorialBoardDesc || '');
        }
      } catch (error) {
        console.error('Error fetching about data:', error);
      }

      try {
        const membersResponse = await siteContentService.get('EDITORIAL_BOARD');
        if (membersResponse.data && membersResponse.data.value) {
          const parsed = JSON.parse(membersResponse.data.value);
          if (Array.isArray(parsed)) {
            setBoardMembers(parsed);
          }
        }
      } catch (error) {
        console.error('Error fetching editorial board:', error);
      }
    };
    fetchData();
  }, []);

  const members = boardMembers.map(member => ({
    role: member.position,
    name: member.name,
    affiliation: member.email,
    expertise: member.bio,
  }));

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">هیئت تحریریه</h1>
          <p className="text-xl text-blue-100">متخصصان برجسته در حوزه معماری و مهندسی</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {editorialBoardDesc && (
          <section className="bg-white rounded-xl shadow-md p-8 mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">درباره هیئت تحریریه</h2>
            <p className="text-lg text-gray-700 leading-relaxed">{editorialBoardDesc}</p>
          </section>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {members.map((member, idx) => (
            <div key={idx} className="bg-white rounded-xl shadow-md p-8 border-r-4 border-blue-700 hover:shadow-lg transition">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Users className="w-8 h-8 text-blue-700" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900">{member.name}</h3>
                  <p className="text-sm text-blue-700 font-semibold">{member.role}</p>
                </div>
              </div>
              <div className="space-y-2">
                <p className="text-gray-700">
                  <span className="font-semibold">تعلق سازمانی:</span> {member.affiliation}
                </p>
                <p className="text-gray-700">
                  <span className="font-semibold">تخصص:</span> {member.expertise}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EditorialBoard;
